import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import principle04 from "./layouts/principle-04/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "d1f0011b-c166-45ad-9efc-ee326d994ed6",
  publicId: "16",
  name: "Equalization",
  difficulty: 2,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, principle02, principle03, principle04, task01],
};

export default lesson;
